export default {"src":"/_next/static/media/img-bfy-mobile-1.af59285d.svg","height":235,"width":157,"blurWidth":0,"blurHeight":0};